import { render, staticRenderFns } from "./PanelCompetitionSettingSidebar.vue?vue&type=template&id=2ac55bba&"
import script from "./PanelCompetitionSettingSidebar.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports